module.exports = __webpack_public_path__ + "img/corporate-light.ee7a323d.png";